import axios from 'axios'
import config from '../../config'

const baseUrl = `${config.backend}company/`

export const registerCompany = async (data) => {
    const response = await axios.post(`${baseUrl}register`, data)
    return response.data
}
